import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons'
import { ActionButton } from 'components'
import { ItemCard } from 'components/item-verification'
import { TripContext } from 'contexts'
import { List } from 'devextreme-react/list'
import DataSource from 'devextreme/data/data_source'
import notify from 'devextreme/ui/notify'
import { ItemVerificationView } from 'enums'
import React, { FC, useContext, useState } from 'react'
import { useNavigation, useOrderItemService, useParamService } from 'services'
import { Temperature } from 'services/enums'
import { LineItem, LineItemBarcode, Order, OrderItem, OrderItemChange } from 'services/types'
import { CheckBoxItem } from 'types'
import './change-approval.scss'

export const ChangeApproval: FC = () => {
    const { getStringValue } = useParamService
    const { navigateTo } = useNavigation()
    const { approveOrderItemChange, isOrderItemChangeComplete, areOrderItemChangesComplete } = useOrderItemService()
    const tripContext = useContext(TripContext)
    
    const stopId: string | undefined = getStringValue('stopId') 
    const tripId: string | undefined = getStringValue('tripId')

    const [temperatures] = useState<CheckBoxItem[]>([
        { id: Temperature.Dry, isSelected: (getStringValue('dry') == 'true'), text: 'Dry', isEnable: true },
        { id: Temperature.Frozen, isSelected: (getStringValue('frozen') == 'true'), text: 'Frozen', isEnable: true },
        { id: Temperature.Refrigerated, isSelected: (getStringValue('ref') == 'true'), text: 'Ref', isEnable: true }
    ])

    const orders: Order[] = tripContext.orders.filter(order => order.stopId.toString() == stopId)
    const stopItems: OrderItem[] = tripContext.orderItems.filter(oi => orders.some(o => o.id == oi.orderId))
    const lineItems: LineItem[] = tripContext.lineItems.filter(li => stopItems.filter(si => si.lineItemId == li.id))
    const temperatureSelectedStopItems: OrderItem[] = stopItems.filter(orderItem => temperatures.some(temp => temp.id === lineItems.find(lineItem => lineItem.id == orderItem.lineItemId)?.temperature && temp.isSelected))

    const orderItemChanges: OrderItemChange[] = tripContext.orderItemChanges.filter(oic => temperatureSelectedStopItems.some(s => s.id == oic.orderItemId))
    const itemsWithChanges: OrderItem[] = tripContext.orderItems.filter(oi => orderItemChanges.some(oic => oic.orderItemId == oi.id))

    const areAllChangesApproved = (): boolean => {
        const changes: OrderItemChange[] = orderItemChanges && orderItemChanges.filter(x => itemsWithChanges.some(i => i.id == x.orderItemId))
        return changes.filter(x => x.isChangeApproved == false).length > 0 ? false : true
    }

    const areAllChangesComplete = (): boolean => {
        const changes: OrderItemChange[]  = (orderItemChanges && orderItemChanges.filter(x => itemsWithChanges.some(i => i.id == x.orderItemId))) ?? []
        let notCompletChanges: OrderItemChange[] = (changes && changes.filter(x => !isOrderItemChangeComplete(x))) ?? []
        return notCompletChanges && notCompletChanges.length > 0 ? false : true
    }

    const handleApproveOrderItemChangClick = (item: OrderItem) => {
        const changes: OrderItemChange[] = (orderItemChanges && orderItemChanges.filter(oic => oic.orderItemId == item.id)) ?? []
        areOrderItemChangesComplete(changes) ? approveOrderItemChange(item) : notify(`Please complete all necessary item change info`, 'info', 5000)
    }
    
    const renderResult = (result: OrderItem) => {
        return <ItemCard
                 orderItemId={result.id} 
                 onDetailsClicked={async () => await navigateTo(`item-details?orderItemId=${result.id}&searchId=${ItemVerificationView.Changes}`)} 
                 onVerifyClicked={async () => await navigateTo(`verify-item?stopId=${stopId}&itemId=${result.lineItemId}`)} 
                 onApproveChangeClicked={() => handleApproveOrderItemChangClick(result)} 
                 showRightHandIcon={(areAllChangesApproved() && areAllChangesComplete())}
                />
    }

    const dataSource = new DataSource({
        store: itemsWithChanges,
        pageSize: 10,
        paginate: true
    })

    return (
        <>
            <div className={'change-approval-message'}>
                Please Review the changes below with the reciever before proceeding to recap
            </div>
            <div>
                <List
                    activeStateEnabled={false}
                    visible={true}
                    dataSource={dataSource}
                    itemRender={renderResult}
                    noDataText={'No Results'}
                />
            </div>
            <div className={'bottom-fix-action-row'}>
                <ActionButton 
                    enabled={areAllChangesComplete() && areAllChangesApproved()}
                    icon={faThumbsUp}
                    buttonColor={'#82BC24'}
                    buttonWidth={'100px'}
                    onClick={() => navigateTo(`recap?tripId=${tripId}&stopId=${stopId}&readOnly=false&dry=${temperatures.find(x => x.id == Temperature.Dry)?.isSelected}&frozen=${temperatures.find(x => x.id == Temperature.Frozen)?.isSelected}&ref=${temperatures.find(x => x.id == Temperature.Refrigerated)?.isSelected}`)}
                    buttonText={'Recap'}
                />
            </div>
        </>
    )
}